import Layout from "components/Layout";
import React from "react";
import LibraryAddForm from "./components/LibraryAddForm";

function AdminLibraryAddPage() {
  return (
    <Layout title="라이브러리 등록">
      <LibraryAddForm />
    </Layout>
  );
}

export default AdminLibraryAddPage;
